let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gE1SW")).then(() => parcelRequire('g0ggp'));